import { Box, Typography } from '@mui/material';
import OperationProductCard from 'components/shared/operation/OperationProductCard/OperationProductCard';

export const EntryDock = ({ workspace, canMutate = false, onPlaceProduct }) => {
  const products = workspace?.docker ?? [];

  if (!products.length) {
    return (
      <Box
        sx={{
          border: '1px dashed',
          borderColor: 'divider',
          borderRadius: 2,
          p: 4,
          textAlign: 'center',
        }}
      >
        <Typography color="text.secondary">محصولی در بارانداز نیست.</Typography>
      </Box>
    );
  }

  return (
    <Box
      sx={{
        display: 'grid',
        gridTemplateColumns: {
          xs: '1fr',
          sm: 'repeat(2, 1fr)',
          md: 'repeat(3, 1fr)',
          xl: 'repeat(4, 1fr)',
        },
        gap: 2,
      }}
    >
      {products.map(product => (
        <OperationProductCard
          key={product.guid || product.key}
          product={product}
          canMutate={canMutate}
          actionLabel="جانمایی"
          onAction={onPlaceProduct}
        />
      ))}
    </Box>
  );
};
